function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { parser, configureNesting } from 'lezer-html';
import { cssLanguage, css } from '@codemirror/lang-css';
import { javascriptLanguage, javascript } from '@codemirror/lang-javascript';
import { syntaxTree, LezerLanguage, indentNodeProp, foldNodeProp, LanguageSupport } from '@codemirror/language';
import { styleTags, tags } from '@codemirror/highlight';
var Targets = ["_blank", "_self", "_top", "_parent"];
var Charsets = ["ascii", "utf-8", "utf-16", "latin1", "latin1"];
var Methods = ["get", "post", "put", "delete"];
var Encs = ["application/x-www-form-urlencoded", "multipart/form-data", "text/plain"];
var Bool = ["true", "false"];
var S = {}; // Empty tag spec

var Tags = {
  a: {
    attrs: {
      href: null,
      ping: null,
      type: null,
      media: null,
      target: Targets,
      hreflang: null
    }
  },
  abbr: S,
  acronym: S,
  address: S,
  applet: S,
  area: {
    attrs: {
      alt: null,
      coords: null,
      href: null,
      target: null,
      ping: null,
      media: null,
      hreflang: null,
      type: null,
      shape: ["default", "rect", "circle", "poly"]
    }
  },
  article: S,
  aside: S,
  audio: {
    attrs: {
      src: null,
      mediagroup: null,
      crossorigin: ["anonymous", "use-credentials"],
      preload: ["none", "metadata", "auto"],
      autoplay: ["autoplay"],
      loop: ["loop"],
      controls: ["controls"]
    }
  },
  b: S,
  base: {
    attrs: {
      href: null,
      target: Targets
    }
  },
  basefont: S,
  bdi: S,
  bdo: S,
  big: S,
  blockquote: {
    attrs: {
      cite: null
    }
  },
  body: S,
  br: S,
  button: {
    attrs: {
      form: null,
      formaction: null,
      name: null,
      value: null,
      autofocus: ["autofocus"],
      disabled: ["autofocus"],
      formenctype: Encs,
      formmethod: Methods,
      formnovalidate: ["novalidate"],
      formtarget: Targets,
      type: ["submit", "reset", "button"]
    }
  },
  canvas: {
    attrs: {
      width: null,
      height: null
    }
  },
  caption: S,
  center: S,
  cite: S,
  code: S,
  col: {
    attrs: {
      span: null
    }
  },
  colgroup: {
    attrs: {
      span: null
    }
  },
  command: {
    attrs: {
      type: ["command", "checkbox", "radio"],
      label: null,
      icon: null,
      radiogroup: null,
      command: null,
      title: null,
      disabled: ["disabled"],
      checked: ["checked"]
    }
  },
  data: {
    attrs: {
      value: null
    }
  },
  datagrid: {
    attrs: {
      disabled: ["disabled"],
      multiple: ["multiple"]
    }
  },
  datalist: {
    attrs: {
      data: null
    }
  },
  dd: S,
  del: {
    attrs: {
      cite: null,
      datetime: null
    }
  },
  details: {
    attrs: {
      open: ["open"]
    }
  },
  dfn: S,
  dir: S,
  div: S,
  dl: S,
  dt: S,
  em: S,
  embed: {
    attrs: {
      src: null,
      type: null,
      width: null,
      height: null
    }
  },
  eventsource: {
    attrs: {
      src: null
    }
  },
  fieldset: {
    attrs: {
      disabled: ["disabled"],
      form: null,
      name: null
    }
  },
  figcaption: S,
  figure: S,
  font: S,
  footer: S,
  form: {
    attrs: {
      action: null,
      name: null,
      "accept-charset": Charsets,
      autocomplete: ["on", "off"],
      enctype: Encs,
      method: Methods,
      novalidate: ["novalidate"],
      target: Targets
    }
  },
  frame: S,
  frameset: S,
  h1: S,
  h2: S,
  h3: S,
  h4: S,
  h5: S,
  h6: S,
  head: {
    children: ["title", "base", "link", "style", "meta", "script", "noscript", "command"]
  },
  header: S,
  hgroup: S,
  hr: S,
  html: {
    attrs: {
      manifest: null
    },
    children: ["head", "body"]
  },
  i: S,
  iframe: {
    attrs: {
      src: null,
      srcdoc: null,
      name: null,
      width: null,
      height: null,
      sandbox: ["allow-top-navigation", "allow-same-origin", "allow-forms", "allow-scripts"],
      seamless: ["seamless"]
    }
  },
  img: {
    attrs: {
      alt: null,
      src: null,
      ismap: null,
      usemap: null,
      width: null,
      height: null,
      crossorigin: ["anonymous", "use-credentials"]
    }
  },
  input: {
    attrs: {
      alt: null,
      dirname: null,
      form: null,
      formaction: null,
      height: null,
      list: null,
      max: null,
      maxlength: null,
      min: null,
      name: null,
      pattern: null,
      placeholder: null,
      size: null,
      src: null,
      step: null,
      value: null,
      width: null,
      accept: ["audio/*", "video/*", "image/*"],
      autocomplete: ["on", "off"],
      autofocus: ["autofocus"],
      checked: ["checked"],
      disabled: ["disabled"],
      formenctype: Encs,
      formmethod: Methods,
      formnovalidate: ["novalidate"],
      formtarget: Targets,
      multiple: ["multiple"],
      readonly: ["readonly"],
      required: ["required"],
      type: ["hidden", "text", "search", "tel", "url", "email", "password", "datetime", "date", "month", "week", "time", "datetime-local", "number", "range", "color", "checkbox", "radio", "file", "submit", "image", "reset", "button"]
    }
  },
  ins: {
    attrs: {
      cite: null,
      datetime: null
    }
  },
  kbd: S,
  keygen: {
    attrs: {
      challenge: null,
      form: null,
      name: null,
      autofocus: ["autofocus"],
      disabled: ["disabled"],
      keytype: ["RSA"]
    }
  },
  label: {
    attrs: {
      for: null,
      form: null
    }
  },
  legend: S,
  li: {
    attrs: {
      value: null
    }
  },
  link: {
    attrs: {
      href: null,
      type: null,
      hreflang: null,
      media: null,
      sizes: ["all", "16x16", "16x16 32x32", "16x16 32x32 64x64"]
    }
  },
  map: {
    attrs: {
      name: null
    }
  },
  mark: S,
  menu: {
    attrs: {
      label: null,
      type: ["list", "context", "toolbar"]
    }
  },
  meta: {
    attrs: {
      content: null,
      charset: Charsets,
      name: ["viewport", "application-name", "author", "description", "generator", "keywords"],
      "http-equiv": ["content-language", "content-type", "default-style", "refresh"]
    }
  },
  meter: {
    attrs: {
      value: null,
      min: null,
      low: null,
      high: null,
      max: null,
      optimum: null
    }
  },
  nav: S,
  noframes: S,
  noscript: S,
  object: {
    attrs: {
      data: null,
      type: null,
      name: null,
      usemap: null,
      form: null,
      width: null,
      height: null,
      typemustmatch: ["typemustmatch"]
    }
  },
  ol: {
    attrs: {
      reversed: ["reversed"],
      start: null,
      type: ["1", "a", "A", "i", "I"]
    },
    children: ["li", "script", "template", "ul", "ol"]
  },
  optgroup: {
    attrs: {
      disabled: ["disabled"],
      label: null
    }
  },
  option: {
    attrs: {
      disabled: ["disabled"],
      label: null,
      selected: ["selected"],
      value: null
    }
  },
  output: {
    attrs: {
      for: null,
      form: null,
      name: null
    }
  },
  p: S,
  param: {
    attrs: {
      name: null,
      value: null
    }
  },
  pre: S,
  progress: {
    attrs: {
      value: null,
      max: null
    }
  },
  q: {
    attrs: {
      cite: null
    }
  },
  rp: S,
  rt: S,
  ruby: S,
  s: S,
  samp: S,
  script: {
    attrs: {
      type: ["text/javascript"],
      src: null,
      async: ["async"],
      defer: ["defer"],
      charset: Charsets
    }
  },
  section: S,
  select: {
    attrs: {
      form: null,
      name: null,
      size: null,
      autofocus: ["autofocus"],
      disabled: ["disabled"],
      multiple: ["multiple"]
    }
  },
  small: S,
  source: {
    attrs: {
      src: null,
      type: null,
      media: null
    }
  },
  span: S,
  strike: S,
  strong: S,
  style: {
    attrs: {
      type: ["text/css"],
      media: null,
      scoped: null
    }
  },
  sub: S,
  summary: S,
  sup: S,
  table: S,
  tbody: S,
  td: {
    attrs: {
      colspan: null,
      rowspan: null,
      headers: null
    }
  },
  textarea: {
    attrs: {
      dirname: null,
      form: null,
      maxlength: null,
      name: null,
      placeholder: null,
      rows: null,
      cols: null,
      autofocus: ["autofocus"],
      disabled: ["disabled"],
      readonly: ["readonly"],
      required: ["required"],
      wrap: ["soft", "hard"]
    }
  },
  tfoot: S,
  th: {
    attrs: {
      colspan: null,
      rowspan: null,
      headers: null,
      scope: ["row", "col", "rowgroup", "colgroup"]
    }
  },
  thead: S,
  time: {
    attrs: {
      datetime: null
    }
  },
  title: S,
  tr: S,
  track: {
    attrs: {
      src: null,
      label: null,
      default: null,
      kind: ["subtitles", "captions", "descriptions", "chapters", "metadata"],
      srclang: null
    }
  },
  tt: S,
  u: S,
  ul: {
    children: ["li", "script", "template", "ul", "ol"]
  },
  var: S,
  video: {
    attrs: {
      src: null,
      poster: null,
      width: null,
      height: null,
      crossorigin: ["anonymous", "use-credentials"],
      preload: ["auto", "metadata", "none"],
      autoplay: ["autoplay"],
      mediagroup: ["movie"],
      muted: ["muted"],
      controls: ["controls"]
    }
  },
  wbr: S
};
var GlobalAttrs = {
  accesskey: null,
  class: null,
  contenteditable: Bool,
  contextmenu: null,
  dir: ["ltr", "rtl", "auto"],
  draggable: ["true", "false", "auto"],
  dropzone: ["copy", "move", "link", "string:", "file:"],
  hidden: ["hidden"],
  id: null,
  inert: ["inert"],
  itemid: null,
  itemprop: null,
  itemref: null,
  itemscope: ["itemscope"],
  itemtype: null,
  lang: ["ar", "bn", "de", "en-GB", "en-US", "es", "fr", "hi", "id", "ja", "pa", "pt", "ru", "tr", "zh"],
  spellcheck: Bool,
  autocorrect: Bool,
  autocapitalize: Bool,
  style: null,
  tabindex: null,
  title: null,
  translate: ["yes", "no"],
  onclick: null,
  rel: ["stylesheet", "alternate", "author", "bookmark", "help", "license", "next", "nofollow", "noreferrer", "prefetch", "prev", "search", "tag"],
  role: /*@__PURE__*/"alert application article banner button cell checkbox complementary contentinfo dialog document feed figure form grid gridcell heading img list listbox listitem main navigation region row rowgroup search switch tab table tabpanel textbox timer".split(" "),
  "aria-activedescendant": null,
  "aria-atomic": Bool,
  "aria-autocomplete": ["inline", "list", "both", "none"],
  "aria-busy": Bool,
  "aria-checked": ["true", "false", "mixed", "undefined"],
  "aria-controls": null,
  "aria-describedby": null,
  "aria-disabled": Bool,
  "aria-dropeffect": null,
  "aria-expanded": ["true", "false", "undefined"],
  "aria-flowto": null,
  "aria-grabbed": ["true", "false", "undefined"],
  "aria-haspopup": Bool,
  "aria-hidden": Bool,
  "aria-invalid": ["true", "false", "grammar", "spelling"],
  "aria-label": null,
  "aria-labelledby": null,
  "aria-level": null,
  "aria-live": ["off", "polite", "assertive"],
  "aria-multiline": Bool,
  "aria-multiselectable": Bool,
  "aria-owns": null,
  "aria-posinset": null,
  "aria-pressed": ["true", "false", "mixed", "undefined"],
  "aria-readonly": Bool,
  "aria-relevant": null,
  "aria-required": Bool,
  "aria-selected": ["true", "false", "undefined"],
  "aria-setsize": null,
  "aria-sort": ["ascending", "descending", "none", "other"],
  "aria-valuemax": null,
  "aria-valuemin": null,
  "aria-valuenow": null,
  "aria-valuetext": null
};
var AllTags = /*@__PURE__*/Object.keys(Tags);
var GlobalAttrNames = /*@__PURE__*/Object.keys(GlobalAttrs);

function elementName(doc, tree) {
  var tag = tree.firstChild;
  var name = tag && tag.getChild("TagName");
  return name ? doc.sliceString(name.from, name.to) : "";
}

function findParentElement(tree) {
  var skip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  for (var cur = tree.parent; cur; cur = cur.parent) {
    if (cur.name == "Element") {
      if (skip) skip = false;else return cur;
    }
  }

  return null;
}

function allowedChildren(doc, tree) {
  var parent = findParentElement(tree, true);
  var parentInfo = parent ? Tags[elementName(doc, parent)] : null;
  return (parentInfo === null || parentInfo === void 0 ? void 0 : parentInfo.children) || AllTags;
}

function openTags(doc, tree) {
  var open = [];

  for (var parent = tree; parent = findParentElement(parent);) {
    var tagName = elementName(doc, parent);
    if (tagName && parent.lastChild.name == "CloseTag") break;
    if (tagName && open.indexOf(tagName) < 0 && (tree.name == "EndTag" || tree.from >= parent.firstChild.to)) open.push(tagName);
  }

  return open;
}

var identifier = /^[:\-\.\w\u00b7-\uffff]+$/;

function completeTag(state, tree, from, to) {
  var end = /\s*>/.test(state.sliceDoc(to, to + 5)) ? "" : ">";
  return {
    from: from,
    to: to,
    options: allowedChildren(state.doc, tree).map(function (tagName) {
      return {
        label: tagName,
        type: "type"
      };
    }).concat(openTags(state.doc, tree).map(function (tag, i) {
      return {
        label: "/" + tag,
        apply: "/" + tag + end,
        type: "type",
        boost: 99 - i
      };
    })),
    span: /^\/?[:\-\.\w\u00b7-\uffff]*$/
  };
}

function completeCloseTag(state, tree, from, to) {
  var end = /\s*>/.test(state.sliceDoc(to, to + 5)) ? "" : ">";
  return {
    from: from,
    to: to,
    options: openTags(state.doc, tree).map(function (tag, i) {
      return {
        label: tag,
        apply: tag + end,
        type: "type",
        boost: 99 - i
      };
    }),
    span: identifier
  };
}

function completeStartTag(state, tree, pos) {
  var options = [],
      level = 0;

  var _iterator = _createForOfIteratorHelper(allowedChildren(state.doc, tree)),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var tagName = _step.value;
      options.push({
        label: "<" + tagName,
        type: "type"
      });
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var _iterator2 = _createForOfIteratorHelper(openTags(state.doc, tree)),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var open = _step2.value;
      options.push({
        label: "</" + open + ">",
        type: "type",
        boost: 99 - level++
      });
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return {
    from: pos,
    to: pos,
    options: options,
    span: /^<\/?[:\-\.\w\u00b7-\uffff]*$/
  };
}

function completeAttrName(state, tree, from, to) {
  var elt = findParentElement(tree),
      info = elt ? Tags[elementName(state.doc, elt)] : null;
  var names = info && info.attrs ? Object.keys(info.attrs).concat(GlobalAttrNames) : GlobalAttrNames;
  return {
    from: from,
    to: to,
    options: names.map(function (attrName) {
      return {
        label: attrName,
        type: "property"
      };
    }),
    span: identifier
  };
}

function completeAttrValue(state, tree, from, to) {
  var _a;

  var nameNode = (_a = tree.parent) === null || _a === void 0 ? void 0 : _a.getChild("AttributeName");
  var options = [],
      span = undefined;

  if (nameNode) {
    var attrName = state.sliceDoc(nameNode.from, nameNode.to);
    var attrs = GlobalAttrs[attrName];

    if (!attrs) {
      var elt = findParentElement(tree),
          info = elt ? Tags[elementName(state.doc, elt)] : null;
      attrs = (info === null || info === void 0 ? void 0 : info.attrs) && info.attrs[attrName];
    }

    if (attrs) {
      var base = state.sliceDoc(from, to).toLowerCase(),
          quoteStart = '"',
          quoteEnd = '"';

      if (/^['"]/.test(base)) {
        span = base[0] == '"' ? /^[^"]*$/ : /^[^']*$/;
        quoteStart = "";
        quoteEnd = state.sliceDoc(to, to + 1) == base[0] ? "" : base[0];
        base = base.slice(1);
        from++;
      } else {
        span = /^[^\s<>='"]*$/;
      }

      var _iterator3 = _createForOfIteratorHelper(attrs),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var value = _step3.value;
          options.push({
            label: value,
            apply: quoteStart + value + quoteEnd,
            type: "constant"
          });
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }

  return {
    from: from,
    to: to,
    options: options,
    span: span
  };
}

function completeHTML(context) {
  var state = context.state,
      pos = context.pos,
      around = syntaxTree(state).resolve(pos),
      tree = around.resolve(pos, -1);

  if (tree.name == "TagName") {
    return tree.parent && /CloseTag$/.test(tree.parent.name) ? completeCloseTag(state, tree, tree.from, pos) : completeTag(state, tree, tree.from, pos);
  } else if (tree.name == "StartTag") {
    return completeTag(state, tree, pos, pos);
  } else if (tree.name == "StartCloseTag" || tree.name == "IncompleteCloseTag") {
    return completeCloseTag(state, tree, pos, pos);
  } else if (context.explicit && (tree.name == "OpenTag" || tree.name == "SelfClosingTag") || tree.name == "AttributeName") {
    return completeAttrName(state, tree, tree.name == "AttributeName" ? tree.from : pos, pos);
  } else if (tree.name == "Is" || tree.name == "AttributeValue" || tree.name == "UnquotedAttributeValue") {
    return completeAttrValue(state, tree, tree.name == "Is" ? pos : tree.from, pos);
  } else if (context.explicit && (around.name == "Element" || around.name == "Text" || around.name == "Document")) {
    return completeStartTag(state, tree, pos);
  } else {
    return null;
  }
}
/**
A language provider based on the [Lezer HTML
parser](https://github.com/lezer-parser/html), wired up with the
JavaScript and CSS parsers to parse the content of `<script>` and
`<style>` tags.
*/


var htmlLanguage = /*@__PURE__*/LezerLanguage.define({
  parser: /*@__PURE__*/parser.configure({
    props: [/*@__PURE__*/indentNodeProp.add({
      Element: function Element(context) {
        var after = /^(\s*)(<\/)?/.exec(context.textAfter);
        if (context.node.to <= context.pos + after[0].length) return context.continue();
        return context.lineIndent(context.state.doc.lineAt(context.node.from)) + (after[2] ? 0 : context.unit);
      },
      "OpenTag CloseTag SelfClosingTag": function OpenTagCloseTagSelfClosingTag(context) {
        return context.column(context.node.from) + context.unit;
      },
      Document: function Document(context) {
        if (context.pos + /\s*/.exec(context.textAfter)[0].length < context.node.to) return context.continue();
        var endElt = null,
            close;

        for (var cur = context.node;;) {
          var last = cur.lastChild;
          if (!last || last.name != "Element" || last.to != cur.to) break;
          endElt = cur = last;
        }

        if (endElt && !((close = endElt.lastChild) && (close.name == "CloseTag" || close.name == "SelfClosingTag"))) return context.lineIndent(context.state.doc.lineAt(endElt.from)) + context.unit;
        return null;
      }
    }), /*@__PURE__*/foldNodeProp.add({
      Element: function Element(node) {
        var first = node.firstChild,
            last = node.lastChild;
        if (!first || first.name != "OpenTag") return null;
        return {
          from: first.to,
          to: last.name == "CloseTag" ? last.from : node.to
        };
      }
    }), /*@__PURE__*/styleTags({
      AttributeValue: tags.string,
      "Text RawText": tags.content,
      "StartTag StartCloseTag SelfCloserEndTag EndTag SelfCloseEndTag": tags.angleBracket,
      TagName: tags.tagName,
      "MismatchedCloseTag/TagName": [tags.tagName, tags.invalid],
      AttributeName: tags.propertyName,
      UnquotedAttributeValue: tags.string,
      Is: tags.definitionOperator,
      "EntityReference CharacterReference": tags.character,
      Comment: tags.blockComment,
      ProcessingInst: tags.processingInstruction,
      DoctypeDecl: tags.documentMeta
    })],
    nested: /*@__PURE__*/configureNesting([{
      tag: "script",
      attrs: function attrs(_attrs) {
        return !_attrs.type || /^(?:text|application)\/(?:x-)?(?:java|ecma)script$|^module$|^$/i.test(_attrs.type);
      },
      parser: javascriptLanguage.parser
    }, {
      tag: "style",
      attrs: function attrs(_attrs2) {
        return (!_attrs2.lang || _attrs2.lang == "css") && (!_attrs2.type || /^(text\/)?(x-)?(stylesheet|css)$/i.test(_attrs2.type));
      },
      parser: cssLanguage.parser
    }])
  }),
  languageData: {
    commentTokens: {
      block: {
        open: "<!--",
        close: "-->"
      }
    },
    indentOnInput: /^\s*<\/$/
  }
});
/**
HTML tag completion. Opens and closes tags and attributes in a
context-aware way.
*/

var htmlCompletion = /*@__PURE__*/htmlLanguage.data.of({
  autocomplete: completeHTML
});
/**
Language support for HTML, including
[`htmlCompletion`](https://codemirror.net/6/docs/ref/#lang-html.htmlCompletion) and JavaScript and
CSS support extensions.
*/

function html() {
  return new LanguageSupport(htmlLanguage, [htmlCompletion, javascript().support, css().support]);
}

export { html, htmlCompletion, htmlLanguage };